module.exports = __webpack_public_path__ + "static/img/modal_prev.a7832deb.svg";